import React, { Component } from 'react';
import { MODAL_INVALID_LAYER } from '../../util/enums/EnumModals';

class ModalInvalidLayer extends Component {
  static modalType() {
    return MODAL_INVALID_LAYER;
  }

  static reducer() {
    return null;
  }

  static title() {
    return 'Invalid layer';
  }

  render() {
    return (
      <div className="alert alert-danger" role="alert">
        <span className="glyphicon glyphicon-exclamation-sign" /> Please fix
        broken layer above before continuing.
      </div>
    );
  }
}

export default ModalInvalidLayer;
